import React from "react";
import {
  qhseBg,
  supplyLiner1,
  supplyLiner2,
  supplyLiner3,
  supplyLiner4,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Liner = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Liner hanger system" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("LINER HANGER SYSTEM")}
            </p>

            <p className="mt-5 text-[20px] font-semibold text-[#141615]">
              {t("Available Products")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("Noncemented Retrievable Liner Hanger PHN-E")}</li>
              <li>{t("Noncemented Liner Hanger PHN1")}</li>
              <li>{t("Noncemented Liner Hanger PHN2")}</li>
              <li>
                {t("Noncemented Liner Hanger rotating while running in PHNV")}
              </li>
              <li>{t("Noncemented Liner Hanger with oriented PHN-KO")}</li>
              <li>{t("Protected Cemented Liner Hanger PHCZ")}</li>
              <li>{t("Protected Rotated Cemented Liner Hanger PHCZV")}</li>
              <li>{t("Hydro-Mechanical Cemented Liner Hanger PHGMC")}</li>
              <li>
                {t("Protected Hydro-Mechanical Cemented Liner Hanger PHGMCZ")}
              </li>
              <li>
                {t("Liner Hanger with disconnection before cementing PHRC")}
              </li>
              <li>{t("Cemented Liner Hanger for flush-joint pipes PHCBT")}</li>
              <li>{t("Protected Liner Hanger for stage cementing PHZSC")}</li>
              <li>
                {t("Liner hanger assembly, revolving while cementing PHVC")}
              </li>
              <li>
                {t(
                  "Liner Hanger with two kinds of release before cementing PHGMRC"
                )}
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-2 gap-4 mt-8 md:mt-0">
            <img
              src={supplyLiner1}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyLiner2}
              alt="Drill Bit 2"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyLiner3}
              alt="Drill Bit 3"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyLiner4}
              alt="Drill Bit 3"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Liner;
